export const setCurrentDetailsAction = (data) => {
    return {
        type: "GET_RVD_DETAILS",
        payload: data,
    };
};
